import mock from "./mock";

import "./data/note";
import "./data/todo";
import "./data/chat";
import "./data/ecommerce";
import "./data/passcode";

mock.onAny().passThrough();
